module.exports = __webpack_public_path__ + "img/orange_003.802b6f43.png";